export default "__VITE_ASSET__dnHlGoaE__"